import React, {Component} from 'react';
import {connect} from 'react-redux';

class GameMessage extends Component {
    render() {
        const {over, won, keepPlaying, inputManager} = this.props;
        return (
            <div
                className={`game-message ${won && !keepPlaying
                ? 'game-won'
                : (over
                    ? 'game-over'
                    : '')}`}>
                <p>{won && !keepPlaying
                        ? 'Вы победили!'
                        : (over
                            ? 'Игра окончена!'
                            : '')}</p>
                <div className="lower">
                    <a className="keep-playing-button" onClick={inputManager.keepPlaying}>Продолжить</a>
                    <a className="retry-button" onClick={inputManager.restart}>Пробовать снова</a>
                </div>
            </div>
        )
    }
}
export default connect(({over, won, keepPlaying, inputManager}) => {
    return {over, won, keepPlaying, inputManager};
}, {})(GameMessage);


// WEBPACK FOOTER //
// ./src/components/web/game/game-message.jsx